import { render } from "./CaptureFolio.vue?vue&type=template&id=3df0676e"
import script from "./CaptureFolio.vue?vue&type=script&lang=js"
export * from "./CaptureFolio.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__